import primaryLogoUrl from '../../../brand/logo/app-icon/se-primary-logo-384.webp'

export const brand = {
  chineseName: '2026 软件工程新生数字计划',
  englishName: 'SE Freshman Digital 2026',
  unofficialNotice:
    '由软件工程学长发起的非官方新生数字计划，具体培养方案与通知以学校和学院正式信息为准。',
  primaryLogoUrl,
} as const
